import https from '../../utils/request.js';

export const updateUser = (params) => {
    return https.post('/v1/user/update', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const updatePassword = (params) => {
    return https.post('/v1/user/update/password', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const updateAccount = (params) => {
    return https.post('/v1/user/update/account', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const messageList = (params) => {
    return https.post('/v1/user/message/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const userInfo = (params) => {
    return https.post('/v1/user/info', params,{'Content-Type ':'application/json;charset=UTF-8'})
}

export const userLoginByToken = (token) => {
    return https.get(`/v1/user/login/token/${token}`, {}, {'Content-Type':'application/json;charset=UTF-8'})
}

export const clockSearch = (params) => {
    return https.post('/v1/user/clock/search', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const userAdd = (params) => {
    return https.post('/v1/user/add', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const userLogin = (params) => {
    return https.post('/v1/user/login', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const uploadAvatar = (params) => {
    return https.post('/v1/user/upload/avatar', params,{'Content-Type':'multipart/form-data'})
}

export const sendSms = (params) => {
    return https.post('/v1/sms/send', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const getClockOpera = (params) => {
    return https.post('/v1/set/config/clock/opera', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const getClocklist = (params) => {
    return https.post('/v1/set/config/user/clock/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const getAchievementList = (params) => {
    return https.post('/v1/achievement/user/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}
